// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import "./ProductDetails.css";
// import { motion } from "framer-motion";
// import { FaStar } from "react-icons/fa";
// import Navber from "../Home/Navbar.jsx";
// import Footer from "../Home/Footer.jsx";
// import Api from "../Utills/Api";
// import { toast } from "react-toastify";
// import axios from "axios";
// import { FiArrowLeft } from "react-icons/fi";
// import logo from "../../Frozenwala.png";

// const ProductDetails = ({ refreshCart }) => {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [product, setProduct] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [cartItems, setCartItems] = useState({});
//   const [stock, setStock] = useState({});

//   const [itemMedia, setItemMedia] = useState([]);
//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const [comment, setComment] = useState("");
//   const [rating, setRating] = useState(0);
//   const [hover, setHover] = useState(0);

//   const [reviews, setReviews] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalReviews, setTotalReviews] = useState(0);
//   const [loadingReviews, setLoadingReviews] = useState(false);
//   const [submittingReview, setSubmittingReview] = useState(false);

//   const uid = localStorage.getItem("user_id");
//   const pageSize = 5;

//   useEffect(() => {
//     const pendingReview = localStorage.getItem("pending_review");
//     if (pendingReview) {
//       const { id: pendingId, rating: pendingRating, comment: pendingComment } = JSON.parse(pendingReview);
//       if (pendingId === id) {
//         setRating(pendingRating);
//         setComment(pendingComment);
//         setTimeout(() => {
//           localStorage.removeItem("pending_review");
//         }, 1000);
//       }
//     }
//   }, []);

//   useEffect(() => {
//     const fetchProduct = async () => {
//       try {
//         const response = await fetch(
//           `https://backend.frozenwala.com/api/product-detail/?product_id=${id}`
//         );
//         if (!response.ok) {
//           throw new Error("Failed to fetch product");
//         }
//         const data = await response.json();
//         setProduct(data.product);

//         const itemMediaFiles = [{ "media_path": data.product.item_photo, "media_type": "image" }, ...data.product.image_gallery];
//         setItemMedia(itemMediaFiles);
//         setCurrentImageIndex(0);

//         getCartItems();
//         getStock();

//         fetchReviews(1);

//         setLoading(false);
//       } catch (err) {
//         setError(err.message);
//         setLoading(false);
//       }
//     };

//     fetchProduct();
//   }, [id]);

//   // Scroll to top when component mounts
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   const fetchReviews = async (page = 1) => {
//     if (!id) return;

//     setLoadingReviews(true);
//     try {
//       const response = await Api.get(`api/review-list/${id}/?page=${page}&page_size=${pageSize}`);

//       if (response.data) {
//         setReviews(response.data.reviews || []);
//         setCurrentPage(response.data.current_page || 1);
//         setTotalPages(response.data.total_pages || 1);
//         setTotalReviews(response.data.total_reviews || 0);
//       }
//     } catch (error) {
//       console.error("Error fetching reviews:", error);
//     } finally {
//       setLoadingReviews(false);
//     }
//   };

//   const getCartItems = async () => {
//     if (!uid) return;
//     try {
//       const response = await Api.get(`api/get_cart/?user_id=${uid}`);
//       const map = {};
//       response.data.forEach((item) => (map[item.product_id] = item.quantity));
//       setCartItems(map);
//     } catch (error) {
//       console.error("Error fetching cart items:", error);
//     }
//   };

//   const getStock = async () => {
//     try {
//       const response = await axios.get(`https://backend.frozenwala.com/api/stock/`);
//       const map = {};
//       response.data.forEach((item) => (map[item.item_id] = item.openingstock));
//       setStock(map);
//     } catch (error) {
//       console.error("Error getting stock:", error);
//     }
//   };

//   const onPressAddToCart = async (productId) => {
//     if (!product) return;

//     const available = stock[productId] || product.stock || 0;
//     if (available === 0) {
//       toast.error("No stock available");
//       return;
//     }

//     if (uid) {
//       try {
//         await Api.post(`api/add_to_cart/`, {
//           product_id: productId,
//           u_id: uid
//         });

//         setCartItems(prev => ({
//           ...prev,
//           [productId]: (prev[productId] || 0) + 1
//         }));

//         if (refreshCart) refreshCart();

//         toast.success("Added to cart successfully!");
//       } catch (error) {
//         console.error("Error adding product to cart:", error);
//         toast.error("Failed to add to cart");
//       }
//     } else {
//       navigate("/login");
//     }
//   };

//   const addOne = async (productId) => {
//     if (!uid) {
//       navigate("/login");
//       return;
//     }

//     const available = stock[productId] || product?.stock || 0;
//     const currentQty = cartItems[productId] || 0;

//     if (available > currentQty) {
//       try {
//         await Api.post(`api/increase/main/`, {
//           product_id: productId,
//           user_id: uid
//         });

//         setCartItems(prev => ({
//           ...prev,
//           [productId]: currentQty + 1
//         }));

//         if (refreshCart) refreshCart();
//         toast.success("Quantity increased");
//       } catch (error) {
//         console.error("Error increasing quantity:", error);
//         toast.error("Failed to increase quantity");
//       }
//     } else {
//       toast.error(`Only ${available} items available in stock.`);
//     }
//   };

//   const subOne = async (productId) => {
//     if (!uid) return;

//     if (cartItems[productId] > 1) {
//       try {
//         await Api.post(`api/decrease/main/`, {
//           product_id: productId,
//           user_id: uid
//         });

//         setCartItems(prev => ({
//           ...prev,
//           [productId]: prev[productId] - 1,
//         }));

//         if (refreshCart) refreshCart();
//         toast.info("Quantity decreased");
//       } catch (error) {
//         console.error("Error decreasing quantity:", error);
//         toast.error("Failed to decrease quantity");
//       }
//     } else {
//       try {
//         await Api.post(`api/remove_from_cart/`, {
//           product_id: productId,
//           user_id: uid
//         });

//         const updatedCartItems = { ...cartItems };
//         delete updatedCartItems[productId];
//         setCartItems(updatedCartItems);

//         if (refreshCart) refreshCart();
//         toast.info("Item removed from cart");
//       } catch (error) {
//         console.error("Error removing from cart:", error);
//         toast.error("Failed to remove from cart");
//       }
//     }
//   };

//   const handleSubmitReview = async () => {
//     if (!uid) {
//       if (rating > 0 || comment.trim() !== "") {
//         localStorage.setItem("pending_review", JSON.stringify({ id, rating, comment }));
//       }
//       toast.error("Please login to submit a review");
//       navigate("/login/?next=" + window.location.pathname);
//       return;
//     }

//     if (rating === 0) {
//       toast.error("Please select a rating");
//       return;
//     }

//     if (comment.trim() === "") {
//       toast.error("Please write a review");
//       return;
//     }

//     setSubmittingReview(true);
//     try {
//       const response = await Api.post(`api/review/${id}/`, {
//         rating: rating,
//         review_text: comment.trim()
//       });

//       if (response.data) {
//         toast.success("Review submitted successfully!");
//         setComment("");
//         setRating(0);

//         const productResponse = await fetch(
//           `https://backend.frozenwala.com/api/product-detail/?product_id=${id}`
//         );
//         if (productResponse.ok) {
//           const productData = await productResponse.json();
//           setProduct(productData.product);
//         }

//         fetchReviews(1);
//       }
//     } catch (error) {
//       console.error("Error submitting review:", error);
//       toast.error("Failed to submit review");
//     } finally {
//       setSubmittingReview(false);
//     }
//   };

//   const handlePageChange = (newPage) => {
//     if (newPage >= 1 && newPage <= totalPages) {
//       fetchReviews(newPage);
//     }
//   };

//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric'
//     });
//   };

//   if (loading) {
//     return (
//       <>
//         <Navber fixedTop={true} />
//         <div style={{ marginTop: "140px", textAlign: "center", minHeight: "60vh" }}>
//           <div className="spinner-border text-primary" role="status" />
//           <p className="mt-2 text-muted">Loading product details...</p>
//         </div>
//         <Footer />
//       </>
//     );
//   }

//   if (error || !product) {
//     return (
//       <>
//         <Navber fixedTop={true} />
//         <div style={{ marginTop: "140px", textAlign: "center", minHeight: "60vh" }}>
//           <div className="alert alert-warning max-w-md mx-auto">{error || "Product not found."}</div>
//         </div>
//         <Footer />
//       </>
//     );
//   }

//   const isInCart = cartItems[product.id] > 0;
//   const availableStock = product.stock || 0;

//   const ratingValue = typeof product.rating === 'object'
//     ? (product.rating?.average || 0)
//     : (product.rating || 0);

//   const productTotalReviews = typeof product.rating === 'object'
//     ? (product.rating?.total_reviews || 0)
//     : 0;

//   const renderPagination = () => {
//     const pages = [];
//     const maxVisiblePages = 5;

//     let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
//     let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

//     if (endPage - startPage + 1 < maxVisiblePages) {
//       startPage = Math.max(1, endPage - maxVisiblePages + 1);
//     }

//     for (let i = startPage; i <= endPage; i++) {
//       pages.push(
//         <button
//           key={i}
//           onClick={() => handlePageChange(i)}
//           style={{
//             padding: '8px 14px',
//             margin: '0 4px',
//             border: `1px solid ${currentPage === i ? '#5dc5fa' : '#ddd'}`,
//             backgroundColor: currentPage === i ? '#5dc5fa' : 'white',
//             color: currentPage === i ? 'white' : '#333',
//             borderRadius: '50px',
//             fontWeight: '600',
//             fontSize: '13px',
//             cursor: 'pointer'
//           }}
//         >
//           {i}
//         </button>
//       );
//     }

//     return (
//       <div className="pagination" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '30px' }}>
//         <button
//           onClick={() => handlePageChange(currentPage - 1)}
//           disabled={currentPage === 1}
//           style={{
//             padding: '8px 16px',
//             margin: '0 4px',
//             border: '1px solid #ddd',
//             backgroundColor: currentPage === 1 ? '#f5f5f5' : 'white',
//             color: currentPage === 1 ? '#999' : '#333',
//             borderRadius: '50px',
//             fontWeight: '600',
//             fontSize: '13px',
//             cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
//           }}
//         >
//           Previous
//         </button>
//         {pages}
//         <button
//           onClick={() => handlePageChange(currentPage + 1)}
//           disabled={currentPage === totalPages}
//           style={{
//             padding: '8px 16px',
//             margin: '0 4px',
//             border: '1px solid #ddd',
//             backgroundColor: currentPage === totalPages ? '#f5f5f5' : 'white',
//             color: currentPage === totalPages ? '#999' : '#333',
//             borderRadius: '50px',
//             fontWeight: '600',
//             fontSize: '13px',
//             cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
//           }}
//         >
//           Next
//         </button>
//       </div>
//     );
//   };

//   return (
//     <>
//       <style>{`
//         .details-page-wrapper {
//           margin-top: 130px !important;
//           max-width: 1400px;
//           margin: 0 auto;
//           padding: 0 24px;
//           min-height: 80vh;
//         }
//         .details-back-btn {
//           display: inline-flex;
//           align-items: center;
//           gap: 8px;
//           background: #ffffff;
//           border: 1px solid #e2e8f0;
//           border-radius: 50px;
//           padding: 8px 18px;
//           font-size: 14px;
//           font-weight: 600;
//           color: #4a5568;
//           cursor: pointer;
//           transition: all 0.2s ease;
//           box-shadow: 0 2px 6px rgba(0,0,0,0.03);
//           margin-bottom: 24px;
//         }
//         .details-back-btn:hover {
//           background: #f7fafc;
//           border-color: #cbd5e0;
//           transform: translateX(-2px);
//         }
//         .details-main-grid {
//           display: grid;
//           grid-template-columns: 1.15fr 0.85fr;
//           gap: 48px;
//           align-items: start;
//         }
//         .details-viewer-panel {
//           display: flex;
//           flex-direction: column;
//           gap: 32px;
//           grid-column: 1; 
//         }
//         .details-main-card {
//           background: #ffffff;
//           border-radius: 24px;
//           border: 1px solid rgba(0,0,0,0.03);
//           box-shadow: 0 10px 30px rgba(0,0,0,0.06);
//           overflow: hidden;
//           width: 100%;
//         }
//         .details-image-viewport {
//           position: relative;
//           width: 100%;
//           height: 480px;
//           background: #fafafa;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           overflow: hidden;
//         }
//         .details-full-img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover !important;
//         }
//         .details-nav-arrow {
//           position: absolute;
//           top: 50%;
//           transform: translateY(-50%);
//           background: rgba(255,255,255,0.9);
//           backdrop-filter: blur(4px);
//           border: 1px solid #e2e8f0;
//           color: #5dc5fa;
//           width: 44px;
//           height: 44px;
//           border-radius: 50%;
//           font-size: 20px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           cursor: pointer;
//           box-shadow: 0 4px 12px rgba(0,0,0,0.08);
//           transition: all 0.2s ease;
//           z-index: 10;
//           border: none;
//           outline: none;
//         }
//         .details-nav-arrow:hover {
//           background: #5dc5fa;
//           color: #ffffff;
//           border-color: #5dc5fa;
//         }
//         .details-thumb-container {
//           display: flex;
//           gap: 12px;
//           flex-wrap: wrap;
//           padding: 16px;
//           justify-content: center;
//           background: #ffffff;
//           border-top: 1px solid #f1f5f9;
//         }
//         .details-thumb-item {
//           width: 76px;
//           height: 76px;
//           object-fit: cover;
//           border-radius: 12px;
//           cursor: pointer;
//           transition: all 0.2s ease;
//         }
//         .details-content-panel {
//           grid-column: 2; 
//           position: sticky;
//           top: 100px;
//         }
//         .details-info-title {
//           font-size: 32px;
//           font-weight: 800;
//           color: #1a202c;
//           line-height: 1.2;
//           margin-bottom: 14px;
//         }
//         .details-badge-cat {
//           display: inline-block;
//           font-size: 12px;
//           font-weight: 700;
//           padding: 6px 14px;
//           border-radius: 50px;
//           background: #ffebee;
//           color: #5dc5fa;
//           border: 2px solid #5dc5fa;
//           text-transform: uppercase;
//           letter-spacing: 0.5px;
//           margin-bottom: 16px;
//         }
//         .details-meta-pill {
//           display: inline-flex;
//           align-items: center;
//           gap: 6px;
//           background: #f7fafc;
//           border-radius: 50px;
//           padding: 6px 14px;
//           font-size: 14px;
//           color: #4a5568;
//           font-weight: 600;
//         }
//         .details-price-tag {
//           font-size: 36px;
//           font-weight: 800;
//           color: #111;
//           margin: 20px 0;
//           display: flex;
//           align-items: center;
//           gap: 12px;
//           flex-wrap: wrap;
//         }
//         .details-btn-buy {
//           background: #5dc5fa !important;
//           color: #ffffff !important;
//           font-weight: 700;
//           font-size: 16px;
//           border: none !important;
//           padding: 14px 32px;
//           border-radius: 50px !important;
//           width: 100%;
//           box-shadow: 0 6px 20px rgba(241, 114, 40, 0.25);
//           cursor: pointer;
//         }
//         .details-btn-cart-qty {
//           width: 44px;
//           height: 44px;
//           border-radius: 50%;
//           border: 2px solid #5dc5fa;
//           background: #ffffff;
//           color: #5dc5fa;
//           font-size: 22px;
//           font-weight: 700;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           cursor: pointer;
//           transition: all 0.2s ease;
//         }
//         .details-btn-cart-qty:hover {
//           background: #5dc5fa;
//           color: #ffffff;
//         }
//         .details-btn-goto-cart {
//           padding: 12px 28px;
//           background: #e41f26;
//           color: white;
//           border: none;
//           border-radius: 50px;
//           font-weight: 700;
//           cursor: pointer;
//           box-shadow: 0 4px 14px rgba(255, 179, 14, 0.2);
//         }
//         .details-desc-box {
//           color: #4a5568;
//           line-height: 1.6;
//           font-size: 15px;
//           border-top: 1px solid #edf2f7;
//           border-bottom: 1px solid #edf2f7;
//           padding: 20px 0;
//           margin: 24px 0;
//         }
//         .review-section {
//           background: #ffffff;
//           padding: 28px;
//           border-radius: 24px;
//           border: 1px solid rgba(0,0,0,0.03);
//           box-shadow: 0 10px 30px rgba(0,0,0,0.04);
//           margin-bottom: 40px; 
//         }
//         @media (max-width: 991.98px) {
//           .details-page-wrapper {
//             margin-top: 100px !important;
//             padding: 0 16px;
//           }
//           .details-main-grid {
//             display: flex;
//             flex-direction: column;
//             gap: 32px;
//           }
//           .details-viewer-panel {
//             order: 1; 
//             width: 100%;
//           }
//           .details-main-card {
//             border-radius: 16px;
//           }
//           .details-image-viewport {
//             height: 340px !important; 
//             width: 100%;
//           }
//           .details-content-panel {
//             order: 2; 
//             position: static;
//           }
//           .review-section {
//             order: 3; 
//             margin-bottom: 20px;
//           }
//           .details-info-title {
//             font-size: 24px;
//           }
//         }
//       `}</style>

//       <Navber fixedTop={true} />
      
//       <div className="details-page-wrapper">
//         <button onClick={() => navigate(-1)} className="details-back-btn">
//           <FiArrowLeft size={16} />
//           <span>Back</span>
//         </button>

//         <div className="details-main-grid">
          
//           {/* LEFT COLUMN PANEL - PRODUCT MEDIA CAROUSEL VIEWER */}
//           <div className="details-viewer-panel">
//             <div className="details-main-card">
//               <div className="details-image-viewport">
//                 {itemMedia[currentImageIndex]?.media_type === 'video' ? (
//                   <video
//                     src={itemMedia[currentImageIndex]?.media_path}
//                     controls
//                     className="details-full-img"
//                   />
//                 ) : (
//                   <img
//                     src={itemMedia[currentImageIndex]?.media_path || product.item_photo || logo}
//                     alt={product.title}
//                     className="details-full-img"
//                     onError={(e) => { e.target.src = "/static/media/Frozenwala.png"; }}
//                   />
//                 )}
                
//                 {itemMedia.length > 1 && (
//                   <>
//                     <button
//                       className="details-nav-arrow"
//                       style={{ left: "16px" }}
//                       onClick={() => setCurrentImageIndex((prev) => (prev - 1 + itemMedia.length) % itemMedia.length)}
//                     >
//                       ‹
//                     </button>
//                     <button
//                       className="details-nav-arrow"
//                       style={{ right: "16px" }}
//                       onClick={() => setCurrentImageIndex((prev) => (prev + 1) % itemMedia.length)}
//                     >
//                       ›
//                     </button>
//                   </>
//                 )}
//               </div>

//               {itemMedia.length > 1 && (
//                 <div className="details-thumb-container">
//                   {itemMedia.map((media, idx) => (
//                     media.media_type === 'video' ? (
//                       <video
//                         key={idx}
//                         src={media.media_path}
//                         className="details-thumb-item"
//                         style={{ border: idx === currentImageIndex ? '3px solid #5dc5fa' : '3px solid #edf2f7' }}
//                         onClick={() => setCurrentImageIndex(idx)}
//                       />
//                     ) : (
//                       <img
//                         key={idx}
//                         src={media.media_path || logo}
//                         alt=""
//                         className="details-thumb-item"
//                         style={{ border: idx === currentImageIndex ? '3px solid #5dc5fa' : '3px solid #edf2f7' }}
//                         onClick={() => setCurrentImageIndex(idx)}
//                       />
//                     )
//                   ))}
//                 </div>
//               )}
//             </div>

//             {/* RENDER DESKTOP REVIEW CONTEXT DIRECTLY BENEATH THE IMAGE VIEWER */}
//             <div className="review-section d-none d-lg-block">
//               <h4 className="fw-bold mb-4" style={{ color: "#2d3748" }}>Customer Reviews ({totalReviews})</h4>

//               <div style={{ marginBottom: '30px', padding: '24px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '16px' }}>
//                 <h5 className="fw-bold mb-3" style={{ fontSize: "16px" }}>Write a Review</h5>
//                 <div style={{ marginBottom: '16px' }}>
//                   <p className="mb-2 small fw-bold text-muted">Your Rating:</p>
//                   <div style={{ display: 'flex', gap: '6px' }}>
//                     {[...Array(5)].map((star, index) => {
//                       const currentRating = index + 1;
//                       return (
//                         <label key={index} className="m-0">
//                           <input
//                             type="radio"
//                             name="rating"
//                             value={currentRating}
//                             onClick={() => setRating(currentRating)}
//                             style={{ display: 'none' }}
//                           />
//                           <FaStar
//                             size={28}
//                             color={currentRating <= (hover || rating) ? "#FFD700" : "#cbd5e1"}
//                             onMouseEnter={() => setHover(currentRating)}
//                             onMouseLeave={() => setHover(0)}
//                             style={{ cursor: 'pointer', transition: "color 0.1s ease" }}
//                           />
//                         </label>
//                       );
//                     })}
//                   </div>
//                 </div>
//                 <div style={{ marginBottom: '16px' }}>
//                   <textarea
//                     placeholder="Share your experience with this product..."
//                     value={comment}
//                     onChange={(e) => setComment(e.target.value)}
//                     style={{
//                       width: '100%',
//                       minHeight: '100px',
//                       padding: '12px',
//                       border: '1px solid #cbd5e1',
//                       borderRadius: '12px',
//                       fontSize: '14px',
//                       resize: 'vertical',
//                       outline: 'none'
//                     }}
//                   />
//                 </div>
//                 <button
//                   onClick={handleSubmitReview}
//                   disabled={submittingReview}
//                   style={{
//                     padding: '10px 24px',
//                     backgroundColor: '#5dc5fa',
//                     color: 'white',
//                     border: 'none',
//                     borderRadius: '50px',
//                     fontWeight: '700',
//                     fontSize: '14px',
//                     cursor: submittingReview ? 'not-allowed' : 'pointer',
//                     opacity: submittingReview ? 0.7 : 1
//                   }}
//                 >
//                   {submittingReview ? 'Submitting...' : 'Submit Review'}
//                 </button>
//               </div>

//               <div className="reviews-list">
//                 {loadingReviews ? (
//                   <div style={{ textAlign: 'center', padding: '20px', color: '#718096' }}>Loading reviews...</div>
//                 ) : reviews.length > 0 ? (
//                   <>
//                     {reviews.map((review, i) => (
//                       <motion.div
//                         key={review.id || i}
//                         initial={{ opacity: 0, y: 15 }}
//                         animate={{ opacity: 1, y: 0 }}
//                         transition={{ delay: i * 0.05 }}
//                         style={{
//                           padding: '20px 0',
//                           borderBottom: '1px solid #edf2f7'
//                         }}
//                       >
//                         <div style={{ display: 'flex', justifycontent: 'space-between', alignitems: 'center', marginbottom: '8px' }}>
//                           <strong style={{ fontSize: '15px', color: '#2d3748' }}>{review.user_name}</strong>
//                           <span style={{ color: '#a0aec0', fontSize: '13px' }}>{formatDate(review.created_at)}</span>
//                         </div>
//                         <div style={{ display: 'flex', gap: '3px', marginBottom: '10px', alignItems: "center" }}>
//                           {Array(5).fill().map((_, j) => (
//                             <FaStar key={j} size={14} color={j < review.rating ? "#FFD700" : "#e2e8f0"} />
//                           ))}
//                           <span style={{ marginLeft: '6px', color: '#4a5568', fontSize: '13px', fontWeight: '600' }}>{review.rating.toFixed(1)}</span>
//                         </div>
//                         <p style={{ margin: 0, lineHeight: '1.6', color: '#4a5568', fontSize: '14px' }}>{review.review_text}</p>
//                       </motion.div>
//                     ))}

//                     {totalPages > 1 && renderPagination()}

//                     <div style={{ textAlign: 'center', marginTop: '20px', color: '#718096', fontSize: '13px' }}>
//                       Showing {reviews.length} of {totalReviews} reviews
//                     </div>
//                   </>
//                 ) : (
//                   <div style={{ textAlign: 'center', padding: '30px', color: '#a0aec0', fontSize: '14px' }}>
//                     No reviews yet. Be the first to review this product!
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* RIGHT COLUMN PANEL - PRODUCT CONFIGURATOR */}
//           <motion.div
//             className="details-content-panel"
//             initial={{ y: 30, opacity: 0 }}
//             animate={{ y: 0, opacity: 1 }}
//             transition={{ type: "spring", stiffness: 60 }}
//           >
//             <span className="details-badge-cat">{product.category_name}</span>
//             <h2 className="details-info-title">{product.title}</h2>
            
//             <div className="d-flex align-items-center gap-3 flex-wrap mb-3">
//               <div className="details-meta-pill" style={{ background: "#fef7f2", color: "#5dc5fa" }}>
//                 <FaStar color="#FFD700" size={14} />
//                 <span>{ratingValue.toFixed(1)}</span>
//                 <span className="text-muted fw-normal">({productTotalReviews})</span>
//               </div>
//               <div className="details-meta-pill">Brand: {product.brand_name}</div>
//               <div className="details-meta-pill">Stock: {availableStock}</div>
//             </div>

//             <div className="details-price-tag">
//               <span>₹{product.item_new_price}</span>
//               {product.item_old_price && product.item_old_price > product.item_new_price && (
//                 <>
//                   <span style={{ textDecoration: 'line-through', color: '#a0aec0', fontSize: '20px' }}>
//                     ₹{product.item_old_price}
//                   </span>
//                   <span style={{ background: '#28a745', color: 'white', padding: '4px 12px', borderRadius: '50px', fontSize: '14px', fontWeight: '700' }}>
//                     {product.discount_percentage}% OFF
//                   </span>
//                 </>
//               )}
//             </div>

//             <div className="details-desc-box" dangerouslySetInnerHTML={{ __html: product.description || "No description available." }} />

//             <div className="mb-4">
//               {availableStock === 0 ? (
//                 <button className="details-btn-buy" disabled style={{ opacity: 0.5, cursor: "not-allowed" }}>
//                   Out of Stock
//                 </button>
//               ) : isInCart ? (
//                 <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap">
//                   <div className="d-flex align-items-center gap-3">
//                     <button className="details-btn-cart-qty" onClick={() => subOne(product.id)}>-</button>
//                     <span className="fw-bold fs-5" style={{ minWidth: '24px', textAlign: 'center' }}>{cartItems[product.id]}</span>
//                     <button className="details-btn-cart-qty" onClick={() => addOne(product.id)}>+</button>
//                   </div>
//                   <motion.button 
//                     whileHover={{ scale: 1.03 }} 
//                     whileTap={{ scale: 0.97 }} 
//                     className="details-btn-goto-cart" 
//                     onClick={() => navigate("/cart")}
//                   >
//                     🛒 Go to Cart
//                   </motion.button>
//                 </div>
//               ) : (
//                 <motion.button 
//                   whileHover={{ scale: 1.03, translateY: -2, boxShadow: "0 8px 24px rgba(241, 114, 40, 0.35)" }} 
//                   whileTap={{ scale: 0.97, translateY: 0 }} 
//                   className="details-btn-buy" 
//                   onClick={() => onPressAddToCart(product.id)}
//                 >
//                   🛒 Add to Cart
//                 </motion.button>
//               )}
//             </div>
//           </motion.div>

//           {/* MOBILE VIEW COMPLEMENTS - REVIEWS MOVED TO THE VERY BOTTOM BEFORE FOOTER WALL */}
//           <div className="review-section d-lg-none">
//             <h4 className="fw-bold mb-4" style={{ color: "#2d3748" }}>Customer Reviews ({totalReviews})</h4>

//             <div style={{ marginBottom: '30px', padding: '24px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '16px' }}>
//               <h5 className="fw-bold mb-3" style={{ fontSize: "16px" }}>Write a Review</h5>
//               <div style={{ marginBottom: '16px' }}>
//                 <p className="mb-2 small fw-bold text-muted">Your Rating:</p>
//                 <div style={{ display: 'flex', gap: '6px' }}>
//                   {[...Array(5)].map((star, index) => {
//                     const currentRating = index + 1;
//                     return (
//                       <label key={index} className="m-0">
//                         <input
//                           type="radio"
//                           name="rating"
//                           value={currentRating}
//                           onClick={() => setRating(currentRating)}
//                           style={{ display: 'none' }}
//                         />
//                         <FaStar
//                           size={28}
//                           color={currentRating <= (hover || rating) ? "#FFD700" : "#cbd5e1"}
//                           onMouseEnter={() => setHover(currentRating)}
//                           onMouseLeave={() => setHover(0)}
//                           style={{ cursor: 'pointer', transition: "color 0.1s ease" }}
//                         />
//                       </label>
//                     );
//                   })}
//                 </div>
//               </div>
//               <div style={{ marginBottom: '16px' }}>
//                 <textarea
//                   placeholder="Share your experience with this product..."
//                   value={comment}
//                   onChange={(e) => setComment(e.target.value)}
//                   style={{
//                     width: '100%',
//                     minHeight: '100px',
//                     padding: '12px',
//                     border: '1px solid #cbd5e1',
//                     borderRadius: '12px',
//                     fontSize: '14px',
//                     resize: 'vertical',
//                     outline: 'none'
//                   }}
//                 />
//               </div>
//               <button
//                 onClick={handleSubmitReview}
//                 disabled={submittingReview}
//                 style={{
//                   padding: '10px 24px',
//                   backgroundColor: '#5dc5fa',
//                   color: 'white',
//                   border: 'none',
//                   borderRadius: '50px',
//                   fontWeight: '700',
//                   fontSize: '14px',
//                   cursor: submittingReview ? 'not-allowed' : 'pointer',
//                   opacity: submittingReview ? 0.7 : 1
//                 }}
//               >
//                 {submittingReview ? 'Submitting...' : 'Submit Review'}
//               </button>
//             </div>

//             <div className="reviews-list">
//               {loadingReviews ? (
//                 <div style={{ textAlign: 'center', padding: '20px', color: '#718096' }}>Loading reviews...</div>
//               ) : reviews.length > 0 ? (
//                 <>
//                   {reviews.map((review, i) => (
//                     <div
//                       key={review.id || i}
//                       style={{
//                         padding: '20px 0',
//                         borderBottom: '1px solid #edf2f7'
//                       }}
//                     >
//                       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
//                         <strong style={{ fontSize: '15px', color: '#2d3748' }}>{review.user_name}</strong>
//                         <span style={{ color: '#a0aec0', fontSize: '13px' }}>{formatDate(review.created_at)}</span>
//                       </div>
//                       <div style={{ display: 'flex', gap: '3px', marginBottom: '10px', alignItems: "center" }}>
//                         {Array(5).fill().map((_, j) => (
//                           <FaStar key={j} size={14} color={j < review.rating ? "#FFD700" : "#e2e8f0"} />
//                         ))}
//                         <span style={{ marginLeft: '6px', color: '#4a5568', fontSize: '13px', fontWeight: '600' }}>{review.rating.toFixed(1)}</span>
//                       </div>
//                       <p style={{ margin: 0, lineHeight: '1.6', color: '#4a5568', fontSize: '14px' }}>{review.review_text}</p>
//                     </div>
//                   ))}

//                   {totalPages > 1 && renderPagination()}

//                   <div style={{ textAlign: 'center', marginTop: '20px', color: '#718096', fontSize: '13px' }}>
//                     Showing {reviews.length} of {totalReviews} reviews
//                   </div>
//                 </>
//               ) : (
//                 <div style={{ textAlign: 'center', padding: '30px', color: '#a0aec0', fontSize: '14px' }}>
//                   No reviews yet. Be the first to review this product!
//                 </div>
//               )}
//             </div>
//           </div>

//         </div>
//       </div>

//       <Footer />
//     </>
//   );
// };

// export default ProductDetails;

import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./ProductDetails.css";
import { motion } from "framer-motion";
import { FaStar } from "react-icons/fa";
import { CiHeart } from "react-icons/ci";
import { FaHeart } from "react-icons/fa";
import Navber from "../Home/Navbar.jsx";
import Footer from "../Home/Footer.jsx";
import Api from "../Utills/Api";
import { toast } from "react-toastify";
import axios from "axios";
import { FiArrowLeft } from "react-icons/fi";
import logo from "../../Frozenwala.png";
import { useWishlist } from "../../contexts/WishlistContext";

const ProductDetails = ({ refreshCart }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { wishlist, toggleWishlist, wishlistLoading } = useWishlist();

  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [cartItems, setCartItems] = useState({});
  const [stock, setStock] = useState({});

  const [itemMedia, setItemMedia] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [comment, setComment] = useState("");
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);

  const [reviews, setReviews] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalReviews, setTotalReviews] = useState(0);
  const [loadingReviews, setLoadingReviews] = useState(false);
  const [submittingReview, setSubmittingReview] = useState(false);

  const uid = localStorage.getItem("user_id");
  const pageSize = 5;

  useEffect(() => {
    const pendingReview = localStorage.getItem("pending_review");
    if (pendingReview) {
      const { id: pendingId, rating: pendingRating, comment: pendingComment } = JSON.parse(pendingReview);
      if (pendingId === id) {
        setRating(pendingRating);
        setComment(pendingComment);
        setTimeout(() => {
          localStorage.removeItem("pending_review");
        }, 1000);
      }
    }
  }, []);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await fetch(
          `https://backend.frozenwala.com/api/product-detail/?product_id=${id}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch product");
        }
        const data = await response.json();
        setProduct(data.product);

        const itemMediaFiles = [{ "media_path": data.product.item_photo, "media_type": "image" }, ...data.product.image_gallery];
        setItemMedia(itemMediaFiles);
        setCurrentImageIndex(0);

        getCartItems();
        getStock();

        fetchReviews(1);

        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchProduct();
  }, [id]);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fetchReviews = async (page = 1) => {
    if (!id) return;

    setLoadingReviews(true);
    try {
      const response = await Api.get(`api/review-list/${id}/?page=${page}&page_size=${pageSize}`);

      if (response.data) {
        setReviews(response.data.reviews || []);
        setCurrentPage(response.data.current_page || 1);
        setTotalPages(response.data.total_pages || 1);
        setTotalReviews(response.data.total_reviews || 0);
      }
    } catch (error) {
      console.error("Error fetching reviews:", error);
    } finally {
      setLoadingReviews(false);
    }
  };

  const getCartItems = async () => {
    if (!uid) return;
    try {
      const response = await Api.get(`api/get_cart/?user_id=${uid}`);
      const map = {};
      response.data.forEach((item) => (map[item.product_id] = item.quantity));
      setCartItems(map);
    } catch (error) {
      console.error("Error fetching cart items:", error);
    }
  };

  const getStock = async () => {
    try {
      const response = await axios.get(`https://backend.frozenwala.com/api/stock/`);
      const map = {};
      response.data.forEach((item) => (map[item.item_id] = item.openingstock));
      setStock(map);
    } catch (error) {
      console.error("Error getting stock:", error);
    }
  };

  const onPressAddToCart = async (productId) => {
    if (!product) return;

    const available = stock[productId] || product.stock || 0;
    if (available === 0) {
      toast.error("No stock available");
      return;
    }

    if (uid) {
      try {
        await Api.post(`api/add_to_cart/`, {
          product_id: productId,
          u_id: uid
        });

        setCartItems(prev => ({
          ...prev,
          [productId]: (prev[productId] || 0) + 1
        }));

        if (refreshCart) refreshCart();

        toast.success("Added to cart successfully!");
      } catch (error) {
        console.error("Error adding product to cart:", error);
        toast.error("Failed to add to cart");
      }
    } else {
      navigate("/login");
    }
  };

  const addOne = async (productId) => {
    if (!uid) {
      navigate("/login");
      return;
    }

    const available = stock[productId] || product?.stock || 0;
    const currentQty = cartItems[productId] || 0;

    if (available > currentQty) {
      try {
        await Api.post(`api/increase/main/`, {
          product_id: productId,
          user_id: uid
        });

        setCartItems(prev => ({
          ...prev,
          [productId]: currentQty + 1
        }));

        if (refreshCart) refreshCart();
        toast.success("Quantity increased");
      } catch (error) {
        console.error("Error increasing quantity:", error);
        toast.error("Failed to increase quantity");
      }
    } else {
      toast.error(`Only ${available} items available in stock.`);
    }
  };

  const subOne = async (productId) => {
    if (!uid) return;

    if (cartItems[productId] > 1) {
      try {
        await Api.post(`api/decrease/main/`, {
          product_id: productId,
          user_id: uid
        });

        setCartItems(prev => ({
          ...prev,
          [productId]: prev[productId] - 1,
        }));

        if (refreshCart) refreshCart();
        toast.info("Quantity decreased");
      } catch (error) {
        console.error("Error decreasing quantity:", error);
        toast.error("Failed to decrease quantity");
      }
    } else {
      try {
        await Api.post(`api/remove_from_cart/`, {
          product_id: productId,
          user_id: uid
        });

        const updatedCartItems = { ...cartItems };
        delete updatedCartItems[productId];
        setCartItems(updatedCartItems);

        if (refreshCart) refreshCart();
        toast.info("Item removed from cart");
      } catch (error) {
        console.error("Error removing from cart:", error);
        toast.error("Failed to remove from cart");
      }
    }
  };

  const handleSubmitReview = async () => {
    if (!uid) {
      if (rating > 0 || comment.trim() !== "") {
        localStorage.setItem("pending_review", JSON.stringify({ id, rating, comment }));
      }
      toast.error("Please login to submit a review");
      navigate("/login/?next=" + window.location.pathname);
      return;
    }

    if (rating === 0) {
      toast.error("Please select a rating");
      return;
    }

    if (comment.trim() === "") {
      toast.error("Please write a review");
      return;
    }

    setSubmittingReview(true);
    try {
      const response = await Api.post(`api/review/${id}/`, {
        rating: rating,
        review_text: comment.trim()
      });

      if (response.data) {
        toast.success("Review submitted successfully!");
        setComment("");
        setRating(0);

        const productResponse = await fetch(
          `https://backend.frozenwala.com/api/product-detail/?product_id=${id}`
        );
        if (productResponse.ok) {
          const productData = await productResponse.json();
          setProduct(productData.product);
        }

        fetchReviews(1);
      }
    } catch (error) {
      console.error("Error submitting review:", error);
      toast.error("Failed to submit review");
    } finally {
      setSubmittingReview(false);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      fetchReviews(newPage);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  // Check if product is in wishlist
  const isInWishlist = product ? wishlist.some((w) => w && w.item && w.item.id === product.id) : false;

  if (loading) {
    return (
      <>
        <Navber fixedTop={true} />
        <div style={{ marginTop: "140px", textAlign: "center", minHeight: "60vh" }}>
          <div className="spinner-border text-primary" role="status" />
          <p className="mt-2 text-muted">Loading product details...</p>
        </div>
        <Footer />
      </>
    );
  }

  if (error || !product) {
    return (
      <>
        <Navber fixedTop={true} />
        <div style={{ marginTop: "140px", textAlign: "center", minHeight: "60vh" }}>
          <div className="alert alert-warning max-w-md mx-auto">{error || "Product not found."}</div>
        </div>
        <Footer />
      </>
    );
  }

  const isInCart = cartItems[product.id] > 0;
  const availableStock = product.stock || 0;

  const ratingValue = typeof product.rating === 'object'
    ? (product.rating?.average || 0)
    : (product.rating || 0);

  const productTotalReviews = typeof product.rating === 'object'
    ? (product.rating?.total_reviews || 0)
    : 0;

  const renderPagination = () => {
    const pages = [];
    const maxVisiblePages = 5;

    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          style={{
            padding: '8px 14px',
            margin: '0 4px',
            border: `1px solid ${currentPage === i ? '#5dc5fa' : '#ddd'}`,
            backgroundColor: currentPage === i ? '#5dc5fa' : 'white',
            color: currentPage === i ? 'white' : '#333',
            borderRadius: '50px',
            fontWeight: '600',
            fontSize: '13px',
            cursor: 'pointer'
          }}
        >
          {i}
        </button>
      );
    }

    return (
      <div className="pagination" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '30px' }}>
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          style={{
            padding: '8px 16px',
            margin: '0 4px',
            border: '1px solid #ddd',
            backgroundColor: currentPage === 1 ? '#f5f5f5' : 'white',
            color: currentPage === 1 ? '#999' : '#333',
            borderRadius: '50px',
            fontWeight: '600',
            fontSize: '13px',
            cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
          }}
        >
          Previous
        </button>
        {pages}
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          style={{
            padding: '8px 16px',
            margin: '0 4px',
            border: '1px solid #ddd',
            backgroundColor: currentPage === totalPages ? '#f5f5f5' : 'white',
            color: currentPage === totalPages ? '#999' : '#333',
            borderRadius: '50px',
            fontWeight: '600',
            fontSize: '13px',
            cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
          }}
        >
          Next
        </button>
      </div>
    );
  };

  return (
    <>
      <style>{`
        .details-page-wrapper {
          margin-top: 130px !important;
          max-width: 1400px;
          margin: 0 auto;
          padding: 0 24px;
          min-height: 80vh;
        }
        .details-back-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 50px;
          padding: 8px 18px;
          font-size: 14px;
          font-weight: 600;
          color: #4a5568;
          cursor: pointer;
          transition: all 0.2s ease;
          box-shadow: 0 2px 6px rgba(0,0,0,0.03);
          margin-bottom: 24px;
        }
        .details-back-btn:hover {
          background: #f7fafc;
          border-color: #cbd5e0;
          transform: translateX(-2px);
        }
        .details-main-grid {
          display: grid;
          grid-template-columns: 1.15fr 0.85fr;
          gap: 48px;
          align-items: start;
        }
        .details-viewer-panel {
          display: flex;
          flex-direction: column;
          gap: 32px;
          grid-column: 1; 
        }
        .details-main-card {
          background: #ffffff;
          border-radius: 24px;
          border: 1px solid rgba(0,0,0,0.03);
          box-shadow: 0 10px 30px rgba(0,0,0,0.06);
          overflow: hidden;
          width: 100%;
          position: relative;
        }
        .details-image-viewport {
          position: relative;
          width: 100%;
          height: 480px;
          background: #fafafa;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }
        .details-full-img {
          width: 100%;
          height: 100%;
          object-fit: cover !important;
        }
        .details-nav-arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(255,255,255,0.9);
          backdrop-filter: blur(4px);
          border: 1px solid #e2e8f0;
          color: #5dc5fa;
          width: 44px;
          height: 44px;
          border-radius: 50%;
          font-size: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          box-shadow: 0 4px 12px rgba(0,0,0,0.08);
          transition: all 0.2s ease;
          z-index: 10;
          border: none;
          outline: none;
        }
        .details-nav-arrow:hover {
          background: #5dc5fa;
          color: #ffffff;
          border-color: #5dc5fa;
        }
        .details-thumb-container {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
          padding: 16px;
          justify-content: center;
          background: #ffffff;
          border-top: 1px solid #f1f5f9;
        }
        .details-thumb-item {
          width: 76px;
          height: 76px;
          object-fit: cover;
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        .details-content-panel {
          grid-column: 2; 
          position: sticky;
          top: 100px;
        }
        .details-info-title {
          font-size: 32px;
          font-weight: 800;
          color: #1a202c;
          line-height: 1.2;
          margin-bottom: 14px;
        }
        .details-badge-cat {
          display: inline-block;
          font-size: 12px;
          font-weight: 700;
          padding: 6px 14px;
          border-radius: 50px;
          background: #ffebee;
          color: #5dc5fa;
          border: 2px solid #5dc5fa;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin-bottom: 16px;
        }
        .details-meta-pill {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          background: #f7fafc;
          border-radius: 50px;
          padding: 6px 14px;
          font-size: 14px;
          color: #4a5568;
          font-weight: 600;
        }
        .details-price-tag {
          font-size: 36px;
          font-weight: 800;
          color: #111;
          margin: 20px 0;
          display: flex;
          align-items: center;
          gap: 12px;
          flex-wrap: wrap;
        }
        .details-btn-buy {
          background: #5dc5fa !important;
          color: #ffffff !important;
          font-weight: 700;
          font-size: 16px;
          border: none !important;
          padding: 14px 32px;
          border-radius: 50px !important;
          width: 100%;
          box-shadow: 0 6px 20px rgba(241, 114, 40, 0.25);
          cursor: pointer;
        }
        .details-btn-cart-qty {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          border: 2px solid #5dc5fa;
          background: #ffffff;
          color: #5dc5fa;
          font-size: 22px;
          font-weight: 700;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        .details-btn-cart-qty:hover {
          background: #5dc5fa;
          color: #ffffff;
        }
        .details-btn-goto-cart {
          padding: 12px 28px;
          background: #e41f26;
          color: white;
          border: none;
          border-radius: 50px;
          font-weight: 700;
          cursor: pointer;
          box-shadow: 0 4px 14px rgba(255, 179, 14, 0.2);
        }
        .details-desc-box {
          color: #4a5568;
          line-height: 1.6;
          font-size: 15px;
          border-top: 1px solid #edf2f7;
          border-bottom: 1px solid #edf2f7;
          padding: 20px 0;
          margin: 24px 0;
        }
        .review-section {
          background: #ffffff;
          padding: 28px;
          border-radius: 24px;
          border: 1px solid rgba(0,0,0,0.03);
          box-shadow: 0 10px 30px rgba(0,0,0,0.04);
          margin-bottom: 40px; 
        }
        /* Wishlist icon styles */
        .wishlist-icon-container {
          position: absolute;
          top: 16px;
          right: 16px;
          z-index: 10;
          background: rgba(255, 255, 255, 0.9);
          border-radius: 50%;
          width: 44px;
          height: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
          transition: all 0.2s ease;
          border: 1px solid rgba(0,0,0,0.05);
        }
        .wishlist-icon-container:hover {
          transform: scale(1.1);
          box-shadow: 0 6px 20px rgba(0,0,0,0.15);
        }
        @media (max-width: 991.98px) {
          .details-page-wrapper {
            margin-top: 100px !important;
            padding: 0 16px;
          }
          .details-main-grid {
            display: flex;
            flex-direction: column;
            gap: 32px;
          }
          .details-viewer-panel {
            order: 1; 
            width: 100%;
          }
          .details-main-card {
            border-radius: 16px;
          }
          .details-image-viewport {
            height: 340px !important; 
            width: 100%;
          }
          .details-content-panel {
            order: 2; 
            position: static;
          }
          .review-section {
            order: 3; 
            margin-bottom: 20px;
          }
          .details-info-title {
            font-size: 24px;
          }
          .wishlist-icon-container {
            width: 36px;
            height: 36px;
          }
          .wishlist-icon-container svg {
            width: 18px;
            height: 18px;
          }
        }
      `}</style>

      <Navber fixedTop={true} />
      
      <div className="details-page-wrapper">
        <button onClick={() => navigate(-1)} className="details-back-btn">
          <FiArrowLeft size={16} />
          <span>Back</span>
        </button>

        <div className="details-main-grid">
          
          {/* LEFT COLUMN PANEL - PRODUCT MEDIA CAROUSEL VIEWER */}
          <div className="details-viewer-panel">
            <div className="details-main-card">
              {/* Wishlist Icon */}
              <div
                className="wishlist-icon-container"
                onClick={(e) => {
                  e.stopPropagation();
                  if (!wishlistLoading) toggleWishlist(product);
                }}
              >
                {isInWishlist ? (
                  <FaHeart size={22} color="#e53e3e" />
                ) : (
                  <CiHeart size={24} color="#4a5568" strokeWidth={2} />
                )}
              </div>

              <div className="details-image-viewport">
                {itemMedia[currentImageIndex]?.media_type === 'video' ? (
                  <video
                    src={itemMedia[currentImageIndex]?.media_path}
                    controls
                    className="details-full-img"
                  />
                ) : (
                  <img
                    src={itemMedia[currentImageIndex]?.media_path || product.item_photo || logo}
                    alt={product.title}
                    className="details-full-img"
                    onError={(e) => { e.target.src = "/static/media/Frozenwala.png"; }}
                  />
                )}
                
                {itemMedia.length > 1 && (
                  <>
                    <button
                      className="details-nav-arrow"
                      style={{ left: "16px" }}
                      onClick={() => setCurrentImageIndex((prev) => (prev - 1 + itemMedia.length) % itemMedia.length)}
                    >
                      ‹
                    </button>
                    <button
                      className="details-nav-arrow"
                      style={{ right: "16px" }}
                      onClick={() => setCurrentImageIndex((prev) => (prev + 1) % itemMedia.length)}
                    >
                      ›
                    </button>
                  </>
                )}
              </div>

              {itemMedia.length > 1 && (
                <div className="details-thumb-container">
                  {itemMedia.map((media, idx) => (
                    media.media_type === 'video' ? (
                      <video
                        key={idx}
                        src={media.media_path}
                        className="details-thumb-item"
                        style={{ border: idx === currentImageIndex ? '3px solid #5dc5fa' : '3px solid #edf2f7' }}
                        onClick={() => setCurrentImageIndex(idx)}
                      />
                    ) : (
                      <img
                        key={idx}
                        src={media.media_path || logo}
                        alt=""
                        className="details-thumb-item"
                        style={{ border: idx === currentImageIndex ? '3px solid #5dc5fa' : '3px solid #edf2f7' }}
                        onClick={() => setCurrentImageIndex(idx)}
                      />
                    )
                  ))}
                </div>
              )}
            </div>

            {/* RENDER DESKTOP REVIEW CONTEXT DIRECTLY BENEATH THE IMAGE VIEWER */}
            <div className="review-section d-none d-lg-block">
              <h4 className="fw-bold mb-4" style={{ color: "#2d3748" }}>Customer Reviews ({totalReviews})</h4>

              <div style={{ marginBottom: '30px', padding: '24px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '16px' }}>
                <h5 className="fw-bold mb-3" style={{ fontSize: "16px" }}>Write a Review</h5>
                <div style={{ marginBottom: '16px' }}>
                  <p className="mb-2 small fw-bold text-muted">Your Rating:</p>
                  <div style={{ display: 'flex', gap: '6px' }}>
                    {[...Array(5)].map((star, index) => {
                      const currentRating = index + 1;
                      return (
                        <label key={index} className="m-0">
                          <input
                            type="radio"
                            name="rating"
                            value={currentRating}
                            onClick={() => setRating(currentRating)}
                            style={{ display: 'none' }}
                          />
                          <FaStar
                            size={28}
                            color={currentRating <= (hover || rating) ? "#FFD700" : "#cbd5e1"}
                            onMouseEnter={() => setHover(currentRating)}
                            onMouseLeave={() => setHover(0)}
                            style={{ cursor: 'pointer', transition: "color 0.1s ease" }}
                          />
                        </label>
                      );
                    })}
                  </div>
                </div>
                <div style={{ marginBottom: '16px' }}>
                  <textarea
                    placeholder="Share your experience with this product..."
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    style={{
                      width: '100%',
                      minHeight: '100px',
                      padding: '12px',
                      border: '1px solid #cbd5e1',
                      borderRadius: '12px',
                      fontSize: '14px',
                      resize: 'vertical',
                      outline: 'none'
                    }}
                  />
                </div>
                <button
                  onClick={handleSubmitReview}
                  disabled={submittingReview}
                  style={{
                    padding: '10px 24px',
                    backgroundColor: '#5dc5fa',
                    color: 'white',
                    border: 'none',
                    borderRadius: '50px',
                    fontWeight: '700',
                    fontSize: '14px',
                    cursor: submittingReview ? 'not-allowed' : 'pointer',
                    opacity: submittingReview ? 0.7 : 1
                  }}
                >
                  {submittingReview ? 'Submitting...' : 'Submit Review'}
                </button>
              </div>

              <div className="reviews-list">
                {loadingReviews ? (
                  <div style={{ textAlign: 'center', padding: '20px', color: '#718096' }}>Loading reviews...</div>
                ) : reviews.length > 0 ? (
                  <>
                    {reviews.map((review, i) => (
                      <motion.div
                        key={review.id || i}
                        initial={{ opacity: 0, y: 15 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: i * 0.05 }}
                        style={{
                          padding: '20px 0',
                          borderBottom: '1px solid #edf2f7'
                        }}
                      >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                          <strong style={{ fontSize: '15px', color: '#2d3748' }}>{review.user_name}</strong>
                          <span style={{ color: '#a0aec0', fontSize: '13px' }}>{formatDate(review.created_at)}</span>
                        </div>
                        <div style={{ display: 'flex', gap: '3px', marginBottom: '10px', alignItems: "center" }}>
                          {Array(5).fill().map((_, j) => (
                            <FaStar key={j} size={14} color={j < review.rating ? "#FFD700" : "#e2e8f0"} />
                          ))}
                          <span style={{ marginLeft: '6px', color: '#4a5568', fontSize: '13px', fontWeight: '600' }}>{review.rating.toFixed(1)}</span>
                        </div>
                        <p style={{ margin: 0, lineHeight: '1.6', color: '#4a5568', fontSize: '14px' }}>{review.review_text}</p>
                      </motion.div>
                    ))}

                    {totalPages > 1 && renderPagination()}

                    <div style={{ textAlign: 'center', marginTop: '20px', color: '#718096', fontSize: '13px' }}>
                      Showing {reviews.length} of {totalReviews} reviews
                    </div>
                  </>
                ) : (
                  <div style={{ textAlign: 'center', padding: '30px', color: '#a0aec0', fontSize: '14px' }}>
                    No reviews yet. Be the first to review this product!
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* RIGHT COLUMN PANEL - PRODUCT CONFIGURATOR */}
          <motion.div
            className="details-content-panel"
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ type: "spring", stiffness: 60 }}
          >
            <span className="details-badge-cat">{product.category_name}</span>
            <h2 className="details-info-title">{product.title}</h2>
            
            <div className="d-flex align-items-center gap-3 flex-wrap mb-3">
              <div className="details-meta-pill" style={{ background: "#fef7f2", color: "#5dc5fa" }}>
                <FaStar color="#FFD700" size={14} />
                <span>{ratingValue.toFixed(1)}</span>
                <span className="text-muted fw-normal">({productTotalReviews})</span>
              </div>
              <div className="details-meta-pill">Brand: {product.brand_name}</div>
              <div className="details-meta-pill">Stock: {availableStock}</div>
            </div>

            <div className="details-price-tag">
              <span style={{ textDecoration: 'line-through', color: '#a0aec0', fontSize: '20px' }}>
                    ₹{product.item_old_price}
                  </span>
              
              {product.item_old_price && product.item_old_price > product.item_new_price && (
                <>
                  <span>₹{product.item_new_price}</span>
                  <span style={{ background: '#28a745', color: 'white', padding: '4px 12px', borderRadius: '50px', fontSize: '14px', fontWeight: '700' }}>
                    {product.discount_percentage}% OFF
                  </span>
                </>
              )}
            </div>

            <div className="details-desc-box" dangerouslySetInnerHTML={{ __html: product.description || "No description available." }} />

            <div className="mb-4">
              {availableStock === 0 ? (
                <button className="details-btn-buy" disabled style={{ opacity: 0.5, cursor: "not-allowed" }}>
                  Out of Stock
                </button>
              ) : isInCart ? (
                <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap">
                  <div className="d-flex align-items-center gap-3">
                    <button className="details-btn-cart-qty" onClick={() => subOne(product.id)}>-</button>
                    <span className="fw-bold fs-5" style={{ minWidth: '24px', textAlign: 'center' }}>{cartItems[product.id]}</span>
                    <button className="details-btn-cart-qty" onClick={() => addOne(product.id)}>+</button>
                  </div>
                  <motion.button 
                    whileHover={{ scale: 1.03 }} 
                    whileTap={{ scale: 0.97 }} 
                    className="details-btn-goto-cart" 
                    onClick={() => navigate("/cart")}
                  >
                    🛒 Go to Cart
                  </motion.button>
                </div>
              ) : (
                <motion.button 
                  whileHover={{ scale: 1.03, translateY: -2, boxShadow: "0 8px 24px rgba(241, 114, 40, 0.35)" }} 
                  whileTap={{ scale: 0.97, translateY: 0 }} 
                  className="details-btn-buy" 
                  onClick={() => onPressAddToCart(product.id)}
                >
                  🛒 Add to Cart
                </motion.button>
              )}
            </div>
          </motion.div>

          {/* MOBILE VIEW COMPLEMENTS - REVIEWS MOVED TO THE VERY BOTTOM BEFORE FOOTER WALL */}
          <div className="review-section d-lg-none">
            <h4 className="fw-bold mb-4" style={{ color: "#2d3748" }}>Customer Reviews ({totalReviews})</h4>

            <div style={{ marginBottom: '30px', padding: '24px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '16px' }}>
              <h5 className="fw-bold mb-3" style={{ fontSize: "16px" }}>Write a Review</h5>
              <div style={{ marginBottom: '16px' }}>
                <p className="mb-2 small fw-bold text-muted">Your Rating:</p>
                <div style={{ display: 'flex', gap: '6px' }}>
                  {[...Array(5)].map((star, index) => {
                    const currentRating = index + 1;
                    return (
                      <label key={index} className="m-0">
                        <input
                          type="radio"
                          name="rating"
                          value={currentRating}
                          onClick={() => setRating(currentRating)}
                          style={{ display: 'none' }}
                        />
                        <FaStar
                          size={28}
                          color={currentRating <= (hover || rating) ? "#FFD700" : "#cbd5e1"}
                          onMouseEnter={() => setHover(currentRating)}
                          onMouseLeave={() => setHover(0)}
                          style={{ cursor: 'pointer', transition: "color 0.1s ease" }}
                        />
                      </label>
                    );
                  })}
                </div>
              </div>
              <div style={{ marginBottom: '16px' }}>
                <textarea
                  placeholder="Share your experience with this product..."
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  style={{
                    width: '100%',
                    minHeight: '100px',
                    padding: '12px',
                    border: '1px solid #cbd5e1',
                    borderRadius: '12px',
                    fontSize: '14px',
                    resize: 'vertical',
                    outline: 'none'
                  }}
                />
              </div>
              <button
                onClick={handleSubmitReview}
                disabled={submittingReview}
                style={{
                  padding: '10px 24px',
                  backgroundColor: '#5dc5fa',
                  color: 'white',
                  border: 'none',
                  borderRadius: '50px',
                  fontWeight: '700',
                  fontSize: '14px',
                  cursor: submittingReview ? 'not-allowed' : 'pointer',
                  opacity: submittingReview ? 0.7 : 1
                }}
              >
                {submittingReview ? 'Submitting...' : 'Submit Review'}
              </button>
            </div>

            <div className="reviews-list">
              {loadingReviews ? (
                <div style={{ textAlign: 'center', padding: '20px', color: '#718096' }}>Loading reviews...</div>
              ) : reviews.length > 0 ? (
                <>
                  {reviews.map((review, i) => (
                    <div
                      key={review.id || i}
                      style={{
                        padding: '20px 0',
                        borderBottom: '1px solid #edf2f7'
                      }}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                        <strong style={{ fontSize: '15px', color: '#2d3748' }}>{review.user_name}</strong>
                        <span style={{ color: '#a0aec0', fontSize: '13px' }}>{formatDate(review.created_at)}</span>
                      </div>
                      <div style={{ display: 'flex', gap: '3px', marginBottom: '10px', alignItems: "center" }}>
                        {Array(5).fill().map((_, j) => (
                          <FaStar key={j} size={14} color={j < review.rating ? "#FFD700" : "#e2e8f0"} />
                        ))}
                        <span style={{ marginLeft: '6px', color: '#4a5568', fontSize: '13px', fontWeight: '600' }}>{review.rating.toFixed(1)}</span>
                      </div>
                      <p style={{ margin: 0, lineHeight: '1.6', color: '#4a5568', fontSize: '14px' }}>{review.review_text}</p>
                    </div>
                  ))}

                  {totalPages > 1 && renderPagination()}

                  <div style={{ textAlign: 'center', marginTop: '20px', color: '#718096', fontSize: '13px' }}>
                    Showing {reviews.length} of {totalReviews} reviews
                  </div>
                </>
              ) : (
                <div style={{ textAlign: 'center', padding: '30px', color: '#a0aec0', fontSize: '14px' }}>
                  No reviews yet. Be the first to review this product!
                </div>
              )}
            </div>
          </div>

        </div>
      </div>

      <Footer />
    </>
  );
};

export default ProductDetails;